import polyglotI18nProvider from 'ra-i18n-polyglot';

// Bộ bản dịch nội bộ đầy đủ để giao diện React Admin không rơi về tiếng Anh.
const vi: any = {
  app: {
    misa_invoice_sync_result: 'Đồng bộ HĐ MISA: %{created} thêm, %{updated} cập nhật, %{skipped} bỏ qua, %{invalid} dòng không hợp lệ.',
  },
  ra: {
    action: {
      add_filter: 'Thêm bộ lọc',
      add: 'Thêm',
      back: 'Quay lại',
      bulk_actions: 'Đã chọn 1 mục |||| Đã chọn %{smart_count} mục',
      cancel: 'Hủy',
      clear_array_input: 'Xóa danh sách',
      clear_input_value: 'Xóa giá trị',
      clone: 'Sao chép',
      confirm: 'Xác nhận',
      create: 'Tạo mới',
      create_item: 'Tạo %{item}',
      delete: 'Xóa',
      edit: 'Chỉnh sửa',
      export: 'Xuất dữ liệu',
      list: 'Danh sách',
      refresh: 'Làm mới',
      remove_filter: 'Gỡ bộ lọc này',
      remove_all_filters: 'Gỡ tất cả bộ lọc',
      remove: 'Xóa',
      reset: 'Đặt lại',
      save: 'Lưu',
      search: 'Tìm kiếm',
      search_columns: 'Tìm cột',
      select_all: 'Chọn tất cả',
      select_all_button: 'Chọn tất cả',
      select_row: 'Chọn dòng này',
      show: 'Xem',
      sort: 'Sắp xếp',
      undo: 'Hoàn tác',
      unselect: 'Bỏ chọn',
      expand: 'Mở rộng',
      close: 'Đóng',
      open_menu: 'Mở trình đơn',
      close_menu: 'Đóng trình đơn',
      update: 'Cập nhật',
      move_up: 'Di chuyển lên',
      move_down: 'Di chuyển xuống',
      open: 'Mở',
      toggle_theme: 'Chuyển chế độ sáng/tối',
      select_columns: 'Chọn cột',
      update_application: 'Tải lại ứng dụng',
    },
    boolean: {
      true: 'Có',
      false: 'Không',
      null: ' ',
    },
    page: {
      create: 'Tạo %{name}',
      dashboard: 'Tổng quan',
      edit: '%{name} %{recordRepresentation}',
      error: 'Đã xảy ra lỗi',
      list: '%{name}',
      loading: 'Đang tải',
      not_found: 'Không tìm thấy trang',
      show: '%{name} %{recordRepresentation}',
      empty: 'Chưa có %{name} nào.',
      invite: 'Bạn có muốn tạo mới không?',
      access_denied: 'Không có quyền truy cập',
      authentication_error: 'Lỗi xác thực',
    },
    input: {
      file: {
        upload_several: 'Thả các tệp vào đây hoặc bấm để chọn tệp.',
        upload_single: 'Thả tệp vào đây hoặc bấm để chọn tệp.',
      },
      image: {
        upload_several: 'Thả các ảnh vào đây hoặc bấm để chọn ảnh.',
        upload_single: 'Thả ảnh vào đây hoặc bấm để chọn ảnh.',
      },
      references: {
        all_missing: 'Không tìm thấy dữ liệu tham chiếu.',
        many_missing: 'Ít nhất một dữ liệu tham chiếu liên quan không còn tồn tại.',
        single_missing: 'Dữ liệu tham chiếu liên quan không còn tồn tại.',
      },
      password: {
        toggle_visible: 'Ẩn mật khẩu',
        toggle_hidden: 'Hiện mật khẩu',
      },
    },
    message: {
      about: 'Giới thiệu',
      access_denied: 'Bạn không có quyền truy cập trang này.',
      are_you_sure: 'Bạn có chắc chắn không?',
      authentication_error: 'Máy chủ xác thực trả về lỗi nên không thể kiểm tra thông tin đăng nhập.',
      auth_error: 'Đã xảy ra lỗi khi xác thực phiên đăng nhập.',
      bulk_delete_content: 'Bạn có chắc muốn xóa %{name} này không? |||| Bạn có chắc muốn xóa %{smart_count} mục này không?',
      bulk_delete_title: 'Xóa %{name} |||| Xóa %{smart_count} %{name}',
      bulk_update_content: 'Bạn có chắc muốn cập nhật %{name} %{recordRepresentation} không? |||| Bạn có chắc muốn cập nhật %{smart_count} mục này không?',
      bulk_update_title: 'Cập nhật %{name} %{recordRepresentation} |||| Cập nhật %{smart_count} %{name}',
      clear_array_input: 'Bạn có chắc muốn xóa toàn bộ danh sách không?',
      delete_content: 'Bạn có chắc muốn xóa %{name} này không?',
      delete_title: 'Xóa %{name} %{recordRepresentation}',
      details: 'Chi tiết',
      error: 'Đã xảy ra lỗi phía trình duyệt nên không thể hoàn tất yêu cầu.',
      invalid_form: 'Biểu mẫu chưa hợp lệ. Vui lòng kiểm tra lại các trường.',
      loading: 'Vui lòng đợi',
      no: 'Không',
      not_found: 'Địa chỉ không đúng hoặc liên kết bạn mở không còn tồn tại.',
      select_all_limit_reached: 'Có quá nhiều phần tử. Hệ thống chỉ chọn %{max} phần tử đầu tiên.',
      unsaved_changes: 'Một số thay đổi chưa được lưu. Bạn có chắc muốn bỏ qua không?',
      yes: 'Có',
      placeholder_data_warning: 'Sự cố mạng: Không thể làm mới dữ liệu.',
    },
    navigation: {
      clear_filters: 'Xóa bộ lọc',
      no_filtered_results: 'Không tìm thấy %{name} phù hợp với bộ lọc hiện tại.',
      no_results: 'Không tìm thấy %{name}',
      no_more_results: 'Trang %{page} nằm ngoài phạm vi. Hãy thử trang trước.',
      page_out_of_boundaries: 'Trang %{page} nằm ngoài phạm vi',
      page_out_from_end: 'Không thể chuyển qua trang cuối',
      page_out_from_begin: 'Không thể chuyển về trước trang 1',
      page_range_info: '%{offsetBegin}–%{offsetEnd} trên %{total}',
      partial_page_range_info: '%{offsetBegin}–%{offsetEnd} trên hơn %{offsetEnd}',
      current_page: 'Trang %{page}',
      page: 'Đi đến trang %{page}',
      first: 'Đi đến trang đầu',
      last: 'Đi đến trang cuối',
      next: 'Đi đến trang sau',
      previous: 'Đi đến trang trước',
      page_rows_per_page: 'Số dòng mỗi trang:',
      skip_nav: 'Chuyển đến nội dung',
    },
    sort: {
      sort_by: 'Sắp xếp theo %{field_lower_first} %{order}',
      ASC: 'tăng dần',
      DESC: 'giảm dần',
    },
    auth: {
      auth_check_error: 'Vui lòng đăng nhập để tiếp tục',
      user_menu: 'Hồ sơ',
      username: 'Tên đăng nhập',
      password: 'Mật khẩu',
      email: 'Email',
      sign_in: 'Đăng nhập',
      sign_in_error: 'Đăng nhập không thành công, vui lòng thử lại',
      logout: 'Đăng xuất',
    },
    notification: {
      updated: 'Đã cập nhật phần tử |||| Đã cập nhật %{smart_count} phần tử',
      created: 'Đã tạo phần tử',
      deleted: 'Đã xóa phần tử |||| Đã xóa %{smart_count} phần tử',
      bad_item: 'Phần tử không hợp lệ',
      item_doesnt_exist: 'Phần tử không tồn tại',
      http_error: 'Lỗi kết nối máy chủ',
      data_provider_error: 'Lỗi nguồn dữ liệu. Vui lòng xem thông tin chi tiết trong bảng điều khiển.',
      i18n_error: 'Không thể tải bản dịch cho ngôn ngữ đã chọn',
      canceled: 'Đã hủy thao tác',
      logged_out: 'Phiên làm việc đã kết thúc, vui lòng kết nối lại.',
      not_authorized: 'Bạn không có quyền truy cập dữ liệu này.',
      application_update_available: 'Đã có phiên bản mới.',
      offline: 'Mất kết nối. Không thể tải dữ liệu.',
    },
    validation: {
      required: 'Bắt buộc',
      minLength: 'Phải có ít nhất %{min} ký tự',
      maxLength: 'Không được vượt quá %{max} ký tự',
      minValue: 'Phải lớn hơn hoặc bằng %{min}',
      maxValue: 'Phải nhỏ hơn hoặc bằng %{max}',
      number: 'Phải là một số',
      email: 'Email không hợp lệ',
      oneOf: 'Phải là một trong các giá trị: %{options}',
      regex: 'Phải khớp định dạng: %{pattern}',
      unique: 'Giá trị phải là duy nhất',
    },
    saved_queries: {
      label: 'Truy vấn đã lưu',
      query_name: 'Tên truy vấn',
      new_label: 'Lưu truy vấn hiện tại…',
      new_dialog_title: 'Lưu truy vấn hiện tại với tên',
      remove_label: 'Xóa truy vấn đã lưu',
      remove_label_with_name: 'Xóa truy vấn “%{name}”',
      remove_dialog_title: 'Xóa truy vấn?',
      remove_message: 'Bạn có chắc muốn xóa mục này khỏi danh sách truy vấn đã lưu không?',
      help: 'Lọc danh sách và lưu truy vấn để sử dụng lại sau',
    },
    guesser: {
      empty: {
        title: 'Không có dữ liệu để hiển thị',
        message: 'Vui lòng kiểm tra nguồn dữ liệu',
      },
    },
    configurable: {
      customize: 'Tùy chỉnh',
      configureMode: 'Cấu hình trang này',
      inspector: {
        title: 'Trình kiểm tra',
        content: 'Di chuột lên các thành phần giao diện để cấu hình',
        reset: 'Đặt lại cài đặt',
        hideAll: 'Ẩn tất cả',
        showAll: 'Hiện tất cả',
      },
      Datagrid: {
        title: 'Bảng dữ liệu',
        unlabeled: 'Cột chưa đặt tên số %{column}',
      },
      SimpleForm: {
        title: 'Biểu mẫu',
        unlabeled: 'Trường chưa đặt tên số %{input}',
      },
      SimpleList: {
        title: 'Danh sách',
        primaryText: 'Nội dung chính',
        secondaryText: 'Nội dung phụ',
        tertiaryText: 'Nội dung bổ sung',
      },
    },
  },
};

export const i18nProvider = polyglotI18nProvider(() => vi, 'vi', [
  { locale: 'vi', name: 'Tiếng Việt' },
]);
